jQuery( document ).ready(function() {
			  
  var sizeUs = "";
  jQuery( "label.btooltip" ).each(function() {
  	var size = jQuery( this ).attr( "title" );

	switch (size) {
	  	case '35':
	  		sizeUs = '4½';
	    	break;
    	case '35.5':
	  		sizeUs = '5';
	    	break;
    	case '36':
	  		sizeUs = '5½';
	    	break;
    	case '36.5':
	  		sizeUs = '6';
	    	break;
    	case '37':
	  		sizeUs = '6½';
	    	break;
    	case '37.5':
	  		sizeUs = '7';
	    	break;
    	case '38':
	  		sizeUs = '7½';
	    	break;
    	case '38.5':
	  		sizeUs = '8';
	    	break;
    	case '39':
	  		sizeUs = '8½';
	    	break;
    	case '39.5':
	  		sizeUs = '9';
	    	break;
    	case '40':
	  		sizeUs = '9½';
        	break;
    	case '41':
	  		sizeUs = '10';
	    	break;
    	case '42':
	  		sizeUs = '11';
	    	break;
    	case '43':
	  		sizeUs = '12';
	    	break;
	  default:
	    console.log('No size found');
	}

    jQuery(this ).text( size + " ( US " + sizeUs  + " )");
  });

});
